import { SharedState } from '$utils/sharedState.svelte';

class StateGnosisPayToken extends SharedState<string> {
  private _isValid() {
    if (!this._current) {
      return false;
    }

    const parts = this._current.split('.');

    if (parts.length !== 3) {
      return false;
    }

    const decodedPayload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));

    if (!decodedPayload || typeof decodedPayload.exp !== 'number') {
      return false;
    }

    const { exp } = decodedPayload;
    return exp >= Date.now() / 1000;
  }

  get current(): string | null {
    if (this._isValid()) {
      return this._current;
    }

    this.set(null);
    return null;
  }
}

export const stateGnosisPayToken = new StateGnosisPayToken(null, {
  persistence: { key: 'gnosisPayToken' },
});
